<template>
  <nuxt-link class="content" :to="path" @click.capture="handleClickPath">
    <span class="label">
      <span class="text">{{ text }}</span>
      <Icon
        v-if="isTrialItem"
        class="icon-gift"
        size="2rem"
        name="fluent-emoji-flat:wrapped-gift"
      />
    </span>
    <div class="arrow">
      <Icon class="graphic arrow-off" name="nextSmall" />
      <Icon class="graphic arrow-on" name="nextSmall" />
    </div>
  </nuxt-link>
</template>
<script lang="ts" setup>
import type { NuxtLinkProps } from '#app';

interface Props extends NuxtLinkProps {
  path?: string;
  text: string;
  id: string;
  lockedContent: string;
  contentType: string;
}

const props = defineProps({
  path: null,
  text: null,
  id: null,
  lockedContent: null,
  contentType: null
});

const { handleClickPath, isTrialItem } = useCategoryContentClick(
  {
    lockedContent: props.lockedContent || props.contentType,
    id: props.id,
  },
  props.path
);
</script>
<style lang="scss" scoped>
.content {
  display: grid;
  grid-template-columns: 1fr auto;
  width: 100%;
  padding: 1.6rem var(--padding_horizontal);
  color: var(--color_neutral_900);
  gap: var(--gap_n);
}

.label {
  position: relative;
  padding: calc(var(--gap_l) / 2) 0;
  padding: 0;
  transition: color 300ms $ease-out-quad;
  color: var(--color_neutral_900);
  text-align: left;
  .icon-gift {
    margin-left: 0.6rem;
  }
  @include font('s', '400', 'secondary');

  /* Fractions 4 */

  .text {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      z-index: 0;
      bottom: -0.5rem;
      left: 0;
      width: 100%;
      height: 0.5rem;
      transform: scaleX(0);
      transform-origin: 0%;
      transition: transform 300ms $ease-out-quad;
      background: var(--color_secondary);
    }
  }
}

.arrow {
  position: relative;
  align-self: center;
  width: 2.4rem;
  height: 2.4rem;
  color: var(--color_secondary);
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 0.6rem;
    opacity: 0.15;
    background-color: var(--color_secondary);
  }
  .graphic {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(0) scale(1);
    transition: transform 400ms $ease-out-back 200ms,
      opacity 50ms $ease-in-quad 200ms;
    opacity: 1;
  }
  .arrow-on {
    transform: translateX(-1.4rem) scale(0.8);
    transition: transform 400ms $ease-in-quad, opacity 50ms $ease-in-quad 100ms;
    opacity: 0;
  }
}

a,
button {
  &:hover,
  &:focus,
  &.active,
  &.disabled {
    .arrow-on {
      transform: translateX(0) scale(1);
      transition: transform 350ms $ease-out-back 200ms,
        opacity 80ms $ease-in-circ 200ms;
      opacity: 1;
    }
    .arrow-off {
      transform: translateX(1.8rem) scale(0.6);
      transition: transform 250ms $ease-in-back,
        opacity 100ms $ease-out-quad 160ms;
      opacity: 0;
    }
    .label {
      .text {
        color: var(--color_secondary);
        &::before {
          transform: scaleX(1);
        }
      }
    }
  }
}
</style>
